import { Box, Typography } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import { generationTime } from './generation-time';

export function TechDocsGenerationStatus() {
  const { metadata } = useTechDocsReaderPage();
  const generatedAt =
    metadata.loading || metadata.error
      ? undefined
      : generationTime(metadata.value);

  return (
    <Box width="100%" mb={2}>
      <Typography variant="body2" color="textSecondary">
        {!metadata.loading && !metadata.error && (
          <>
            {generatedAt ? (
              <>
                Last generated:{' '}
                <time dateTime={generatedAt.toISOString()}>
                  {generatedAt.toLocaleString(undefined, {
                    timeZoneName: 'short',
                  })}
                </time>
              </>
            ) : (
              'Generation time unavailable'
            )}
            {' · '}
          </>
        )}
        <Link to="https://github.com/WTS-Paradigm/team-solutions-app-backstage/blob/main/docs/writing-docs.md#how-techdocs-are-generated">
          How TechDocs are generated
        </Link>
      </Typography>
    </Box>
  );
}
